/**
 *  @class
 *  @function GewinnspielSignupForm
 *
 *  Schickt die Gewinnspiel-Anmeldung per fetch ab und blendet den
 *  Danke-Zustand ohne Hard-Reload ein. Faellt in allen unklaren Faellen
 *  auf den nativen Formular-Submit zurueck (progressive enhancement).
 */
if (!customElements.get('gewinnspiel-signup-form')) {
  class GewinnspielSignupForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.signupState = this.querySelector('[data-state-signup]');
      this.thanksState = this.querySelector('[data-state-danke]');
      this.submitButton = this.form ? this.form.querySelector('button[type="submit"]') : null;
      this.nativeSubmit = false;

      // Ohne beide Zustaende im DOM (z. B. serverseitig gerenderter
      // Danke-Zustand) oder ohne fetch bleibt alles beim nativen Verhalten.
      if (!this.form || !this.signupState || !this.thanksState || !window.fetch) {
        return;
      }
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      if (this.nativeSubmit) {
        // Fallback-Pfad: Submit unveraendert durchlassen (Hard-Reload).
        return;
      }
      event.preventDefault();
      this.setLoading(true);

      const formData = new FormData(this.form);
      fetch(this.form.action, {
        method: 'POST',
        body: formData,
        redirect: 'follow',
        headers: {
          Accept: 'text/html'
        }
      })
        .then((response) => {
          // Erfolg nur, wenn Shopify auf das return_to mit customer_posted=true
          // weitergeleitet hat. Landet die Antwort auf /challenge (Captcha) oder
          // ohne den Marker (z. B. Validierungsfehler), hat dieser fetch KEINE
          // Anmeldung angelegt — der native Submit unten ist dann der einzige
          // Post, der zaehlt; ein Doppel-Eintrag ist damit ausgeschlossen.
          if (response.ok && response.url.indexOf('customer_posted=true') > -1 && response.url.indexOf('/challenge') === -1) {
            this.showThanks();
          } else {
            this.submitNatively();
          }
        })
        .catch(() => {
          this.submitNatively();
        });
    }

    submitNatively() {
      this.nativeSubmit = true;
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
      } else {
        this.form.submit();
      }
    }

    setLoading(loading) {
      if (!this.submitButton) {
        return;
      }
      this.submitButton.classList.toggle('loading', loading);
      this.submitButton.disabled = loading;
    }

    showThanks() {
      this.setLoading(false);
      this.signupState.hidden = true;
      this.thanksState.hidden = false;

      const heading = this.thanksState.querySelector('.gewinnspiel-signup__heading');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
      const code = this.thanksState.querySelector('.gewinnspiel-signup__code');
      const scrollTarget = code || this.thanksState;
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  customElements.define('gewinnspiel-signup-form', GewinnspielSignupForm);
}
